import React from "react";

export const PendingText = ({ t }) => (
  <span className="text-secondary">{t("generic:pending")}</span>
);
